import { useMutation } from '@tanstack/react-query';
import Client from '@/common/utils/client.utility';

interface RemoveBasketItemPayloadType {
  vendorId: number | undefined | null;
  productVariantId: number;
}

type RemoveBasketItemType = (
  params: RemoveBasketItemPayloadType
) => Promise<[]>;

const removeBasketItem: RemoveBasketItemType = async (
  payload: RemoveBasketItemPayloadType
) => {
  const client = new Client();

  return await client.delete(`/v1/Basket/Shopper/RemoveItem`, {}, payload);
};

export const useRemoveBasketItem = () => {
  return useMutation({
    mutationFn: removeBasketItem,
    retry: 1,
  });
};
